module.exports = __webpack_public_path__ + "02_medium_gold.445cb791.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/02_medium_gold.png
// module id = A59a
// module chunks = 0